<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <!--    복도 및 화장실청소-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="true"
      :table-header-title="'자가진단 항목'"
      :table-header-yes="'작성'"
      :table-header-no="'미작성'"
      :table-header-na="'N/A'"
      :table-header-note="'비고'"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      
      
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '복도 및 화장실청소',
      form: {
        inspectionTitle: '복도 및 화장실청소',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return  [
        {
          id: 1,
          label: '바닥에 작업자가 걸려 넘어질 위험이 있는 장애물은 제거하였는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 2,
          label: '근로자의 통행에 장해가 없도록 채광 또는 조명시설이 충분한가?',
          is_checked: '',
          note: '',
        },
        {
          id: 3,
          label: '교차점이나 코너에는 충돌방지용 거울을 설치하였는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 4,
          label: '다른 사람과 충돌을 방지하기 위해 우측통행을 하는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 5,
          label: '화장실 타일이 깨지거나 비어있는 부분은 없는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 6,
          label: '청소 전 화장실 내부에 사람이 있는 지 확인하였는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 7,
          label: '화장실 천정이나 높은 벽 청소 시 사용하는 사다리에 미끄럼방지 조치를 하였는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 8,
          label: '화장실 세면대나 변기 위에 올라가서 작업을 하지 않는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 9,
          label: '청소 중에는 “청소 중”을 알리는 표지를 하고 작업하는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 10,
          label: '청소 후 바닥에 미끄러운 세제나 물기를 깨끗이 제거하는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 11,
          label: '청소도구를 지정된 위치에 보관하는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 12,
          label: '자극성 세제를 이용한 청소 시 고무장갑을 착용하는가?',
          is_checked: '',
          note: '',
        },
        {
          id: 13,
          label: '청소 중에는 미끄럼 방지용 장화를 착용하는가?',
          is_checked: '',
          note: '',
        },

      ]

    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
    updateListNote (indexRows, text) {
      this.form.inspectList[indexRows].note = text
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
